module.exports = __webpack_public_path__ + "img/align-center.b1e63b8c.svg";